module.exports = __webpack_public_path__ + "img/down-arrow-swirl-red.57db88a2.svg";